import { render } from "./personalCenterPage.vue?vue&type=template&id=a24c6c16&scoped=true"
import script from "./personalCenterPage.vue?vue&type=script&lang=js"
export * from "./personalCenterPage.vue?vue&type=script&lang=js"

import "./personalCenterPage.vue?vue&type=style&index=0&id=a24c6c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24c6c16"]])

export default __exports__